import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FlexDirective } from '@ngbracket/ngx-layout/flex';

@Component({
    selector: 'app-maes-diogelwch-teiar-unigol',
    templateUrl: './maes-diogelwch-teiar-unigol.component.html',
    styleUrls: ['./maes-diogelwch-teiar-unigol.component.scss'],
    imports: [FormlyModule, FlexDirective]
})
export class MaesDiogelwchTeiarUnigolComponent extends FieldType<FieldTypeConfig> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {

  }
}
